import { render } from "./Avv.vue?vue&type=template&id=55d3cccc"
import script from "./Avv.vue?vue&type=script&lang=js"
export * from "./Avv.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__